import { AxiosError, AxiosResponse } from 'axios'
import { BaseAxios } from '@/api/axios'
import { ICreateAccountPayload, ILoginPayload, IRenewPayload } from "@/interface/services"
import { IResetPayload, IFinalizeRecoverPayload, IFinalizeRecoverMsisdnPayload } from "@/interface/services"
import { ITokenExpiredPayload, ITokenExpired, ILoggedInUser, IRecoverUser } from '@/interface/services'

// Public routes.

const urlCreate: string = process.env.VUE_APP_URL_SERVICE_IAM_PUBLIC_PATH + "/users/create-password"
const urlLogin: string = process.env.VUE_APP_URL_SERVICE_IAM_PUBLIC_PATH + "/users/login"
const urlNewAccount: string = process.env.VUE_APP_URL_SERVICE_IAM_PUBLIC_PATH + "/users/create-account"
const urlRecover: string = process.env.VUE_APP_URL_SERVICE_IAM_PUBLIC_PATH + "/users/recover-password"
const urlReset: string = process.env.VUE_APP_URL_SERVICE_IAM_PUBLIC_PATH + "/users/reset-password"
const urlToken: string = process.env.VUE_APP_URL_SERVICE_IAM_PUBLIC_PATH + "/token/expired"
const urlStatus: string = process.env.VUE_APP_URL_SERVICE_IAM_PUBLIC_PATH + "/status"

const urlLoginUuid = (uuid: string, token: string) => {
  return `${process.env.VUE_APP_URL_SERVICE_IAM_PUBLIC_PATH}/users/login/${uuid}/${token}`
}

const urlRenewAccess = () => {
  return `${process.env.VUE_APP_URL_SERVICE_IAM_PUBLIC_PATH}/users/renew-access`
}

export default
{
  async getStatus(): Promise<AxiosResponse> {
    return BaseAxios.get<AxiosResponse|void>(urlStatus)
      // eslint-disable-next-line
      .then((response: AxiosResponse|any) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },

  async createAccount(payload: ICreateAccountPayload): Promise<AxiosResponse> {
    return BaseAxios.post<AxiosResponse|void>(urlNewAccount, payload)
      // eslint-disable-next-line
      .then((response: AxiosResponse<any>) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },

  async getTokenStatus(payload: ITokenExpiredPayload): Promise<ITokenExpired> {
    return BaseAxios.post<ITokenExpired|void>(urlToken, payload)
      // eslint-disable-next-line
      .then((response: AxiosResponse<ITokenExpired>|any) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },

  async initRecovery(uuid: string, token: string, isCreate: boolean): Promise<IRecoverUser> {
    return BaseAxios.get<IRecoverUser|void>(`${isCreate?urlCreate:urlRecover}/${uuid}/${token}`)
      // eslint-disable-next-line
      .then((response: AxiosResponse<IRecoverUser>|any) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },

  async login(payload: ILoginPayload): Promise<ILoggedInUser> {
    return BaseAxios.post<ILoggedInUser|void>(urlLogin, payload)
      // eslint-disable-next-line
      .then((response: AxiosResponse<ILoggedInUser>|any) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },

  async loginUuid(uuid: string, token: string): Promise<ILoggedInUser> {
    return BaseAxios.post<ILoggedInUser|void>(urlLoginUuid(uuid, token))
      // eslint-disable-next-line
      .then((response: AxiosResponse<ILoggedInUser>|any) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },

  async renewAccess(payload: IRenewPayload): Promise<ILoggedInUser> {
    return BaseAxios.post<ILoggedInUser|void>(urlRenewAccess(), payload)
      // eslint-disable-next-line
      .then((response: AxiosResponse<ILoggedInUser>|any) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },

  async resetPassword(payload: IResetPayload): Promise<AxiosResponse> {
    return BaseAxios.post<AxiosResponse|void>(urlReset, payload)
      // eslint-disable-next-line
      .then((response: AxiosResponse<any>) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },

  async saveCreateAccount(msisdn: string, code: string, payload: IFinalizeRecoverMsisdnPayload): Promise<AxiosResponse> {
    return BaseAxios.post<AxiosResponse|void>(`${urlCreate}/${msisdn}/${code}`, payload)
      // eslint-disable-next-line
      .then((response: AxiosResponse<any>) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },

  async saveRecovery(uuid: string, token: string, isCreate: boolean, payload: IFinalizeRecoverPayload): Promise<AxiosResponse> {
    return BaseAxios.post<AxiosResponse|void>(`${isCreate?urlCreate:urlRecover}/${uuid}/${token}`, payload)
      // eslint-disable-next-line
      .then((response: AxiosResponse<any>) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },

  async saveRecoveryMsisdn(msisdn: string, code: string, payload: IFinalizeRecoverMsisdnPayload): Promise<AxiosResponse> {
    return BaseAxios.post<AxiosResponse|void>(`${urlRecover}/${msisdn}/${code}`, payload)
      // eslint-disable-next-line
      .then((response: AxiosResponse<any>) => { return response.data })
      .catch((error: AxiosError) => { throw error })
  },
}

